import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import React from 'react'
import { Lang } from '../../dao/SpwkUtil';

type Props = {
  LangA: Lang;
  setLangA: React.Dispatch<React.SetStateAction<Lang>>;

  LangB: Lang;
  setLangB: React.Dispatch<React.SetStateAction<Lang>>;
}

/** 語言選擇器 */
const UcLangPicker = ({
  LangA, setLangA,
  LangB, setLangB
}: Props) => {
  return (
    <Box sx={{ minWidth: 120, p: 1, pt: 3 }}>
      <FormControl sx={{ width: "160px", m: 1 }}>
        <InputLabel shrink={true}>主要語言</InputLabel>
        <Select size="small"
          value={LangA}
          label="主要語言"
          onChange={(e) => { setLangA(e.target.value as any) }}

        >
          <MenuItem value={''}>(空白)</MenuItem>
          <MenuItem value={'CHI'}>中文</MenuItem>
          <MenuItem value={'ENG'}>英文</MenuItem>
          <MenuItem value={'IND'}>印尼</MenuItem>
          <MenuItem value={'THA'}>泰國</MenuItem>
          <MenuItem value={'TGL'}>菲律賓</MenuItem>
          <MenuItem value={'VIE'}>越南</MenuItem>
          <MenuItem value={'RHF_NAME'}>RHF</MenuItem>
          <MenuItem value={'CODE'}>CODE</MenuItem>
        </Select>
      </FormControl>
      <FormControl sx={{ width: "160px", m: 1 }}>
        <InputLabel shrink={true}>次要語言</InputLabel>
        <Select size="small"
          value={LangB}
          label="次要語言"
          onChange={(e) => { setLangB(e.target.value as any) }}
        >
          <MenuItem value={''}>(空白)</MenuItem>
          <MenuItem value={'CHI'}>中文</MenuItem>
          <MenuItem value={'ENG'}>英文</MenuItem>
          <MenuItem value={'IND'}>印尼</MenuItem>
          <MenuItem value={'THA'}>泰國</MenuItem>
          <MenuItem value={'TGL'}>菲律賓</MenuItem>
          <MenuItem value={'VIE'}>越南</MenuItem>
          <MenuItem value={'RHF_NAME'}>RHF</MenuItem>
          <MenuItem value={'CODE'}>CODE</MenuItem>
          <MenuItem value={'HIS'}>HIS資訊</MenuItem>
          <MenuItem value={'GOV'}>GOV申報</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}

export default UcLangPicker
